// import { makeStyles } from "@material-ui/core/styles";
import { makeStyles } from "@mui/styles";
import EOCColors from "./EOCColors";

const useStyles = makeStyles({
  "@global": {
    body: {
      margin: "0",
      background:
        "radial-gradient(circle, rgba(255,255,255,1) 0%, rgba(238,238,221,1) 35%, rgba(238,238,238,1) 100%);",
      //  "radial-gradient(circle, rgba(255,255,255,1) 0%, rgba(238,238,221,1) 35%, rgba(235,237,242,1) 100%);",
      fontFamily: "Arial, Helvetiva, sans-serif",
    },
    ".ui-widget-content": {
      border: "0 !important",
    },
    ".sn-portlet": {
      height: "auto",
      position: "relative",
      zoom: "1",
      fontFamily: "Arial, Helvetiva, sans-serif",
      fontSize: "12px",
      "& .sn-pt-border": {
        border: "0",
        background: "transparent",
        padding: "0",
        transition: "box-shadow .25s",
        borderRadius: "0px",
        backgroundColor: EOCColors.White,
        "&:hover": {
          boxShadow:
            "0 8px 17px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
        },
      },
    },
    ".sn-prc-dock": { top: "60px !important" },
    ".sn-pt-header": {
      padding: "4px",
      margin: "0 0 0 0",
      transition: "box-shadow .25s",
      border: "unset",
      borderRadius: "0px",
      background: "unset",
      backgroundColor: "white !important",
    },
    ".sn-pt-body": {
      padding: "4px",
    },
    ".sn-pt-title": {
      color: EOCColors.Purple,
      margin: "0",
      padding: "0px 0px 10px 0px",
      textTransform: "uppercase",
      lineHeight: "1.2",
      fontSize: "1.125rem",
      fontWeight: "900",
      "&:after": {
        content: "''",
        display: "inline-block",
        width: "8px",
        margin: "0 15px",
        height: "16px",
        backgroundColor: EOCColors.Pink,
        transform: "skew(-15deg)",
      },
    },
    ".sn-verbs-panel": {
      zIndex: 99999,
    },
    ".sn-ctrl": {
      border: "1px solid",
      fontSize: "100%",
      minHeight: "34px",
      color: "#666",
      fontFamily: "Arial, Helvetica, sans-serif",
      background: "#FFFFFF url(/Root/Global/images/inputbg.gif) repeat-x 0 0",
      borderColor: "hsl(0,0%,80%)",
    },
    ".sn-error": {
      color: EOCColors.Red,
    },
    ".sn-ctrl-text": {
      width: "100%",
      verticalAlign: "middle",
    },
    ".sn-ctrl-req": {
      borderColor: EOCColors.Red + "!important",
    },
    ".sn-button": {
      color: EOCColors.Black,
      fontSize: "11px",
      fontFamily: "Arial, Helvetica, sans-serif",
      background: "unset",
      backgroundColor: "#f0f0f0",
      border: "solid 1px #ccc",
      padding: "5px 10px",
      overflow: "visible",
      height: "37px",
      margin: "4px",
      transition: "background-color .2s",
    },
    ".coolimage": {
      backgroundImage:
        "url(/Root/Skins/eocskin/styles/materialize/img/Vlinder-wereldbol.jpg)",
      backgroundRepeat: "no-repeat",
      backgroundOrigin: "padding-box",
      backgroundSize: "cover",
      backgroundPosition: "center",
      height: "100px",
      width: "100%",
    },
    ".hide": {
      display: "none",
    },
    label: {
      minHeight: "40px",
      fontSize: ".7rem",
      fontStyle: "italic",
      fontWeight: "bold",
      lineHeight: "1.4rem",
      color: EOCColors.Gray,
    },
    ".sn-article-img img": {
      maxWidth: "100%",
      height: "auto",
      display: "block",
      margin: "0 auto",
      backgroundColor: "#fff",
      padding: "5px",
    },
    "table.jsgrid-table, thead, tbody, th, td, tr": {
      "@media (max-width: 760px)": {
        display: "block",
      },
    },
    ".jsgrid-row, .jsgrid-alt-row": {
      "@media (max-width: 760px)": {
        borderBottom: "1px solid #eee !important",
      },
    },
    ".jsgrid-alt-row>.jsgrid-cell": {
      "@media (max-width: 760px)": {
        backgroundColor: "#ebf2fa !important",
      },
    },
    ".jsgrid-cell": {
      "@media (max-width: 760px)": {
        /* Behave  like a "row" */
        border: "none !important",
        position: "relative !important",
        paddingLeft: "45% !important",
        minHeight: "30px",
        "&:before": {
          /* Now like a table header */
          position: "absolute !important",
          /* Top/left values mimic padding */
          top: "6px !important",
          left: "6px !important",
          width: "45% !important",
          paddingRight: "10px !important",
          whiteSpace: "nowrap !important",
        },
      },
    },
    ".jsgrid-align-center": {
      "@media (max-width: 760px)": {
        textAlign: "left !important",
      },
    },
    ".jsgrid-align-right": {
      "@media (max-width: 760px)": {
        textAlign: "left !important",
      },
    },
    ".jsgrid-header-row": {
      "@media (max-width: 760px)": {
        display: "none !important",
      },
    },
    ".eocgrid-filter-row": {
      "@media (max-width: 760px)": {
        display: "none !important",
      },
    },
    ".jsgridhide": {
      "@media (max-width: 960px)": {
        display: "none",
      },
      "@media (max-width: 760px)": {
        display: "none",
      },
    },
    ".jsgriddate": {
      width: "105px",
      "@media (max-width: 760px)": {
        width: "auto",
      },
    },
    ".jsgridsmall": {
      width: "85px",
      "@media (max-width: 760px)": {
        width: "auto",
      },
    },
    ".jsgridmedium": {
      width: "150px",
      "@media (max-width: 760px)": {
        width: "auto",
      },
    },
    ".jsgridimportant": {
      minWidth: "100px",
    },
    ".gridlink": {
      fontWeight: "bolder",
      cursor: "pointer",
      "&:hover": {
        color: "#201F60",
        backgroundColor: "#f0f0f0",
        transition: "color .2s",
      },
    },
    ".simpleBorder": {
      marginLeft: "-.3rem",
      marginRight: "-.3rem",
      borderBottom: "1px solid #e50071 !important",
    },
    ".simpleBorder-activeitem": {
      borderLeft: "1px dashed #e50071 !important",
      borderRight: "1px dashed #e50071 !important",
    },
  },
});

export default useStyles;
